import styled from 'styled-components';
import { BORDERS } from 'variables/theme';

export const Border = styled.div`
  border-bottom: ${BORDERS.generic};
  margin-top: 20px;
  margin-bottom: 20px;
`;
